import { SliderModal } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../routes/types';
import { sessionState } from '../../store/session/atom';

import { ImpersonateSelection } from './components/ImpersonateSelection';
import { UserSelection } from './components/UserSelection';
import { ImpersonateMenuContext, ImpersonateMenuProvider } from './context';
import { ImpersonateMenuAction, ImpersonateMenuPage } from './types';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

const ImpersonateMenuBase = () => {
  const { initialPage, setIsOpen, setInitialPage } = useContext(ImpersonateMenuContext);
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { isMaster } = useRecoilValue(sessionState);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const scrollRef = useRef<ScrollView>(null);

  const width = useBreakpointValue({
    base: 1,
    sm: 0.5,
    lg: 0.2,
  });

  const handleDismiss = () => {
    setIsOpen(false);
    navigation.goBack();
  };

  const handleAction = (action: ImpersonateMenuAction, page?: ImpersonateMenuPage) => {
    if (action === ImpersonateMenuAction.Close) {
      handleDismiss();
      return;
    }

    if (page === undefined) {
      return;
    }

    setInitialPage(page);
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        x: initialPage === ImpersonateMenuPage.User ? 0 : initialPage * containerWidth,
        animated: true,
      });
    }
  }, [containerWidth, initialPage]);

  return (
    <SliderModal onDismiss={handleDismiss} width={width}>
      <ScrollView
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        horizontal
        ref={scrollRef}
        style={styles.container}
        onLayout={({ nativeEvent }) => setContainerWidth(nativeEvent.layout.width)}>
        <UserSelection onAction={handleAction} width={containerWidth} />
        {isMaster && <ImpersonateSelection onAction={handleAction} width={containerWidth} />}
      </ScrollView>
    </SliderModal>
  );
};

export const ImpersonateMenu = ImpersonateMenuBase;
export { ImpersonateMenuContext, ImpersonateMenuProvider };
